import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import * as _ from 'lodash';

import { defaultTablePageSize } from '~/common/components/consts';
import {parseSaleFilter, saleFilterParams} from '~/apps/pos/shared/services/qsfilter';
import { getSaleList, setSaleCurrentPage } from '~/apps/pos/shared/actions/sales';
import { getAdditionalFieldByOrgId } from '~/apps/pos/shared/actions/additionalFields';
import SalesListTable from '../../components/sales/SalesListTable';
import { navigate } from '~/router';
import { saleGetListParamsURL } from '~/apps/pos/models';
import { Features } from "~/apps/shared/consts";


class SalesList extends React.Component<any, any> {
  private updateSalesInterval: NodeJS.Timeout;

  componentDidMount(): void {
    const { auth: { currentUser: { organizationId } }, dispatch } = this.props;
    dispatch(getAdditionalFieldByOrgId(organizationId));

    this.updateSalesInterval = setInterval(() => {
      this.onFetchData({ page: this.getCurrentPage(), pageSize: defaultTablePageSize }, null);
    }, 30000);
  }

  getCurrentPage = () => {
    const { sales } = this.props;
    return sales.ui.currentPage;
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.filter && this.props.filter) {
      if (!_.isEqual(prevProps.filter, this.props.filter)) {
        // TODO: Paging should be controlled by the component
        this.onFetchData({ page: 0, pageSize: defaultTablePageSize }, null);
      }
    }
  };

  componentWillUnmount() {
    clearInterval(this.updateSalesInterval);
  }

  onFetchData = (state, instance) => {
    const { orgId, dispatch, filter, information: { entities: { features } } } = this.props;

    const req = {
      offset: state.page * state.pageSize,
    } as saleGetListParamsURL;

    if (orgId) {
      req.organizationId = orgId;
    }

    if (filter) {
      if (filter.locationId) {
        req.locationId = filter.locationId;
      }
      if (filter.q) {
        req.q = filter.q;
      }
      if (filter.status) {
        req.status = filter.status;
      }
      if (filter.departmentId) {
        req.departmentId = filter.departmentId;
      }
      if (filter.startDt) {
        req.startDt = filter.startDt;
      }
      if (filter.endDt) {
        req.endDt = filter.endDt;
      }
    }

    const hasShowSalesTotalsFeature = features.includes(Features.SHOW_COMPLETED_SALES_TOTALS);
    if (hasShowSalesTotalsFeature && (!filter?.startDt || !filter?.endDt)) return;

    dispatch(getSaleList(req));
  };

  onDetail = (model) => {
    const { filter } = this.props;
    navigate('pos.admin.sales.detail', { saleId: model.id, ...saleFilterParams(filter) })
  };

  onDelete = (model) => {
    const { filter } = this.props;
    navigate('pos.admin.sales.delete', { saleId: model.id, ...saleFilterParams(filter) })
  };

  onEdit = (model) => {
    const { filter } = this.props;
    navigate('pos.admin.sales.edit', { saleId: model.id, ...saleFilterParams(filter) });
  }

  onPageChange = (page) => {
    const { dispatch } = this.props;

    dispatch(setSaleCurrentPage(page));
  };

  render() {
    const { sales, organizations, locations, orgId, additionalFields, information } = this.props;
    const _AdditionalFields = additionalFields && additionalFields.ui && additionalFields.ui.currentList
    && additionalFields.entities ? additionalFields.ui.currentList.map(a => additionalFields.entities[a]) : [];
    const _sales = sales && sales.ui && sales.ui.currentList ? sales.ui.currentList.map(u => sales.entities[u]) : [];
    const hasDepartmentFeature = information.entities.features.includes(Features.DEPARTMENTS);
    const hasShowCompanyFeature = information.entities.features.includes(Features.SHOW_COMPANY_FROM_SALE);
    const hasAddCompletedAtFeature = information.entities.features.includes(Features.ADD_COMPLETED_AT);
    const hasHidePoNumberFeature = information.entities.features.includes(Features.PO_NUMBER_NOT_REQUIRED);

    return (
      <SalesListTable
        manual={true}
        orgId={orgId}
        loading={sales.ui.loading}
        page={sales.ui.currentPage}
        data={_sales}
        additionalFields={_AdditionalFields}
        getOrganization={(id) => organizations.entities[id]}
        getLocation={(id) => locations.entities[id]}
        onFetchData={this.onFetchData}
        onDetail={this.onDetail}
        onDelete={this.onDelete}
        onEdit={this.onEdit}
        onPageChange={this.onPageChange}
        hasDepartmentFeature={hasDepartmentFeature}
        features={information.entities.features}
        hasShowCompanyFeature={hasShowCompanyFeature}
        hasAddCompletedAtFeature={hasAddCompletedAtFeature}
        hasHidePoNumberFeature={hasHidePoNumberFeature}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos');
  const { route: { params } } = selector(state);

  // Get current filter and force expired
  const filter = parseSaleFilter(params);

  return {
    auth: state.shared.auth,
    sales: state.pos.sales,
    additionalFields: state.pos.fields,
    organizations: state.shared.organizations,
    locations: state.shared.locations,
    information: state.shared.information,
    filter,
  };
};

export default connect(mapStateToProps)(SalesList);
